import type { ThemeColors } from "./UCIndependentChat/hooks/useTheme";
import type { PageThemeTokens } from "./v2/theme/types";

export interface QuickQuestionTheme {
  accent: string;
  text: string;
  textSecondary: string;
  panelBg: string;
  panelBorder: string;
  itemBg: string;
  itemBorder: string;
  itemHoverBg: string;
  buttonBg: string;
}

export const DEFAULT_QUICK_QUESTION_THEME: QuickQuestionTheme = {
  accent: "#1890ff",
  text: "#262626",
  textSecondary: "#8c8c8c",
  panelBg: "rgba(255, 255, 255, 0.98)",
  panelBorder: "rgba(24, 144, 255, 0.1)",
  itemBg: "rgba(24, 144, 255, 0.02)",
  itemBorder: "rgba(24, 144, 255, 0.1)",
  itemHoverBg: "rgba(24, 144, 255, 0.08)",
  buttonBg: "rgba(255, 255, 255, 0.98)",
};

function withAlpha(color: string, alpha: number): string {
  const hex = color.replace("#", "");
  if (hex.length !== 6) {
    return color;
  }
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function quickQuestionThemeFromPageTokens(
  tokens: PageThemeTokens
): QuickQuestionTheme {
  return {
    accent: tokens.accent,
    text: tokens.text,
    textSecondary: tokens.textSecondary,
    panelBg: tokens.cardBg,
    panelBorder: tokens.border,
    itemBg: tokens.messageBg,
    itemBorder: tokens.border,
    itemHoverBg: tokens.hoverBg,
    buttonBg: tokens.cardBg,
  };
}

export function quickQuestionThemeFromLegacyColors(
  colors: ThemeColors,
  isDark: boolean
): QuickQuestionTheme {
  const accent = colors.evaluationMeta;
  return {
    accent,
    text: colors.text,
    textSecondary: colors.textSecondary,
    panelBg: isDark ? colors.messageBg : "rgba(255, 255, 255, 0.98)",
    panelBorder: isDark ? colors.border : withAlpha(accent, 0.15),
    itemBg: isDark ? colors.hoverBg : withAlpha(accent, 0.04),
    itemBorder: isDark ? colors.border : withAlpha(accent, 0.12),
    itemHoverBg: isDark ? colors.borderSecondary : withAlpha(accent, 0.1),
    buttonBg: isDark ? colors.messageBg : "rgba(255, 255, 255, 0.98)",
  };
}
